<lib-overlayer-message
  [messageType]="messageBoxTypeError"
  [closeMessageBoxTranslation]="'bills.pdfScreen.error.close' | translate"
  [showModal]="(selectDownloadPdf$ | async).hasError"
  (onClose)="closeModal()"
  (footerMainButtonClick)="closeModal()"
  [footerMainButtonLabel]="'bills.pdfScreen.error.close' | translate"
  [showCross]="true"
>
  <p Title class="rs-msgbox-title">
    {{ 'bills.pdfScreen.error.downloadTitle' | translate }}
  </p>
  <p Content>{{ 'bills.pdfScreen.error.download' | translate }}</p>
</lib-overlayer-message>
